import React, { useEffect, useState } from 'react';
import './Styles.css';
import { ServiceClient } from '../../../../Services/ServiceClient';
import { formatMessage } from '../../../../Localization/formatMessage';
import Messages from '../../../../Localization/Messages';
import { BrokerCostType } from '../../../../Enums/BrokerCostType';
import { convertServerDateTime } from '../../../../Helpers/Converter';
import { PresentationMode } from '../../../../Enums/PresentationMode';
import { getRate } from '../../Functions';
import LoaderComponent from '../../../../Elements/ids/Loader';
import ErrorMessage from '../../../../Elements/ErrorMessage';
import { Ui16Check } from '@ids/react-icons';

const CommissionHistory = ({ agentCode, customerNumber }) => {
  const [list, setList] = useState([]);
  const [mode, setMode] = useState(PresentationMode.Loading);

  useEffect(() => {
    if (customerNumber === null || customerNumber === undefined) {
      ServiceClient.getHistoryForDefaultBrokerRate(
        agentCode,
        records => {
          setList(records.sort((a, b) => (a.effective > b.effective ? -1 : 1)).slice(1));
          setMode(PresentationMode.View);
        },
        () => {
          setMode(PresentationMode.Error);
        }
      );
      return;
    }
    ServiceClient.getBrokerCostsActualRatesHistory(
      agentCode,
      customerNumber,
      records => {
        setList(records.sort((a, b) => (a.effective > b.effective ? -1 : 1)).slice(1));
        setMode(PresentationMode.View);
      },
      () => {
        setMode(PresentationMode.Error);
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="commission-page_history-table-container" id="commissionHistoryResults">
      <h3>{formatMessage(Messages.commissionPage_historicalRecordsTitle)}</h3>
      {mode === PresentationMode.Loading ? (
        <LoaderComponent />
      ) : mode === PresentationMode.Error ? (
        <ErrorMessage message={formatMessage(Messages.error_commissionHistory)} />
      ) : (
        <table cellSpacing="0" cellPadding="0">
          <thead>
            <tr>
              <th>{formatMessage(Messages.commissionPage_ValidFrom)}</th>
              <th>{formatMessage(Messages.commissionPage_ValidTo)}</th>
              <th>{formatMessage(Messages.common_updatedBy)}</th>
              <th>{formatMessage(Messages.commissionPage_brokerCostAcceptance)}</th>
              <th>{formatMessage(Messages.commissionPage_personalAcceptance)}</th>
              <th>{formatMessage(Messages.commissionPage_motorAcceptance)}</th>
              <th>{formatMessage(Messages.commissionPage_rateTypeProperty)}</th>
              <th>{formatMessage(Messages.commissionPage_rateTypeLiability)}</th>
              <th>{formatMessage(Messages.commissionPage_rateTypePerson)}</th>
              <th>{formatMessage(Messages.commissionPage_rateTypeTransport)}</th>
              <th>{formatMessage(Messages.commissionPage_rateTypeCasco)}</th>
              <th>{formatMessage(Messages.commissionPage_rateTypePersonalCommission)}</th>
              <th>{formatMessage(Messages.commissionPage_rateTypeMotorCommission)}</th>
            </tr>
          </thead>
          <tbody>
            {list.map((rate, index) => (
              <tr
                key={`commissionHistory${index}`}
                className={
                  rate.customerNumber || !customerNumber ? '' : 'commission-page_history-table-row-inherited '
                }>
                <td>{convertServerDateTime(rate.effective)}</td>
                <td>{convertServerDateTime(rate.expires)}</td>
                <td>
                  {rate.updatedBy.userIdentifier}
                  <br />
                  {rate.updatedBy.sourceSystem}
                </td>
                <td>{rate.useBrokerCost && <Ui16Check />}</td>
                <td>{rate.usePersonalCommission && <Ui16Check />}</td>
                <td>{rate.useMotorCommission && <Ui16Check />}</td>
                <td>{getRate(rate.rates, BrokerCostType.Property)}</td>
                <td>{getRate(rate.rates, BrokerCostType.Liability)}</td>
                <td>{getRate(rate.rates, BrokerCostType.Person)}</td>
                <td>{getRate(rate.rates, BrokerCostType.Transport)}</td>
                <td>{getRate(rate.rates, BrokerCostType.Casco)}</td>
                <td>{getRate(rate.rates, BrokerCostType.PersonalCommission)}</td>
                <td>{getRate(rate.rates, BrokerCostType.MotorCommission)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};
export default CommissionHistory;
